
import React from "react";
import { ResponsiveContainer, BarChart, XAxis, YAxis, Tooltip, Bar, Cell } from "recharts";
import { formatNumberWithCommas } from "./BudgetChartData";

interface BarChartComponentProps {
  data: Array<{name: string, value: number, color: string}>;
}

export const BarChartComponent: React.FC<BarChartComponentProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart 
        data={data} 
        layout="vertical" 
        margin={{
          top: 20,
          right: 30,
          left: 60,
          bottom: 5
        }}
      >
        <XAxis type="number" tickFormatter={value => formatNumberWithCommas(value)} />
        <YAxis type="category" dataKey="name" width={150} />
        <Tooltip formatter={(value: number) => [`$${value.toLocaleString()}`, 'Budget']} />
        <Bar dataKey="value" fill="#8884d8">
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
